import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
/**
 * VENDOR MAPPING — replaced with a new file at design system migration.
 *
 *   Fluent v9 → registry.v9.tsx     { add: AddRegular, close: DismissRegular, … }
 *   shadcn    → registry.lucide.tsx { add: Plus,       close: X,              … }
 *
 * Today this uses Fabric's icon FONT; names must match what's valid in the
 * set loaded via `initializeIcons(...)` in `src/index.tsx`. This name set was
 * derived from real `iconName` usage in the repo.
 */ var FABRIC_ICON_NAMES = {
    add: 'Add',
    backToWindow: 'BackToWindow',
    calendar: 'Calendar',
    check: 'CheckMark',
    chevronDown: 'ChevronDown',
    chevronLeft: 'ChevronLeft',
    chevronRight: 'ChevronRight',
    chevronUp: 'ChevronUp',
    close: 'Cancel',
    copy: 'Copy',
    delete: 'Delete',
    edit: 'Edit',
    fullScreen: 'FullScreen',
    hide: 'Hide',
    info: 'Info',
    lock: 'Lock',
    more: 'More',
    reply: 'Reply',
    ringer: 'Ringer',
    search: 'Search',
    settings: 'Settings',
    subtract: 'CalculatorSubtract',
    warning: 'Warning'
};
/**
 * `TFIcon.tsx` calls this and imports no vendor package itself — so this is
 * the only file that changes at migration.
 */ export var renderRegisteredIcon = function renderRegisteredIcon(_0) {
    var name = _0.name, size = _0.size, color = _0.color, className = _0.className, style = _0.style, rest = _object_without_properties(_0, [
        "name",
        "size",
        "color",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ _jsx(Icon, {
        iconName: FABRIC_ICON_NAMES[name],
        className: className,
        style: _object_spread({
            fontSize: size,
            color: color
        }, style),
        "aria-hidden": rest['aria-hidden'],
        "data-testid": rest['data-testid']
    });
};
